import {IOT_API_BASE} from '../config/vars';
import {call} from './http';

const _METHODS = {
    command: {
        HelloCommand: 'GET',
        GetPsInfoCommand: 'GET',
        InternetSpeedTestCommand: 'GET',
        GetCameraStoreCommand: 'GET',
        AvailableCommands: 'GET',
        GetNetworkInfoCommand: 'GET',
        DescribeCommand: 'GET',
        GetThumbnailCommand: 'GET',
        GetONVIFConnectionInfoCommand: 'GET',
        GetArpNeighboursCommand: 'GET',
        GetRecidsStatusCommand: 'GET',
        UpdateHandledRecids: 'PUT',
        UpdateRecidConfiguration: 'PUT',
        UpdateDeviceToken: 'PUT',
        GetSoftwareVersionCommand: 'GET',
        SetStaticONVIFCommand: 'PUT',
        NmapCommand: 'GET',
        GetCameraRegistryCommand: 'GET',
        RemoveCameraRegistryEntryCommand: 'DELETE',
        AddCameraRegistryEntryCommand: 'PUT',
        NVRScanCommand: 'GET',
        DeviceRebootCommand: 'PUT',
        ShutdownCommand: 'PUT',
        GetNodeSnapshotCommand: 'GET',
        GetRegistryMonitorSnapshotCommand: 'GET',
        GetNodeStatsSnapshotCommand: 'GET',
    },

    update: {
        UpdateRecidConfiguration: 'PUT',
        UpdateOpenSSHTunnel: 'PUT',
        UpdateDeviceToken: 'PUT',
        UpdateDeviceConfiguration: 'PUT',
        UpdateHandledRecids: 'PUT',
        LiveStreamCommand: 'PUT',
    }
}


export const device = {
    command: (command, deviceName, options = null, route = "command", fetchOptions = {}) => {
        if (!_METHODS.hasOwnProperty(route))
            throw new Error(`Invalid route ${route}`);
        else if (!_METHODS[route].hasOwnProperty(command))
            throw new Error(`Invalid command ${command} on route ${route}`);

        const method = _METHODS[route][command];
        if (['GET', 'DELETE'].includes(method))
            return call({
                path: `${IOT_API_BASE}/api/v1/${route}/devel/${deviceName}/${command}` + (options ? `?${new URLSearchParams(options).toString()}` : ""),
                fetchOptions: {method: method, ...fetchOptions},
                otherOptions: {disableErrorToasts: true}
            })
        else if (['PUT', 'POST', 'PATCH'].includes(method))
            return call({
                path: `${IOT_API_BASE}/api/v1/${route}/devel/${deviceName}/${command}`,
                fetchOptions: {method: method, body: JSON.stringify(options || {}), ...fetchOptions},
                otherOptions: {disableErrorToasts: true}
            })
        else
            throw new Error(`Invalid method ${method}`);
    },

    ping: (deviceName) => {
        return call({
            path: `${IOT_API_BASE}/api/v1/command/devel/${deviceName}/HelloCommand`,
            fetchOptions: {method: 'GET'},
        });
    }
};
